export default __webpack_public_path__ + "static/media/auto_elek_1019_4.9d907767.jpg";